// Global variable set by /config.js, which is loaded by a script tag in index.html
const { datasetConfig } = window

export default datasetConfig
